import loadScript from '../util/loader';
import {register} from '../vendor/theme-scripts/theme-sections';
import {mapStyle} from '../vendor/google-map-styles';

window.theme.allMaps = window.theme.allMaps || {};
let allMaps = window.theme.allMaps;

class Map {
  constructor(section) {
    this.container = section.container;
    this.mapWrap = this.container.querySelector('[data-map-container]');
    this.styleString = this.container.getAttribute('data-style') || '';
    this.key = this.container.getAttribute('data-api-key');
    this.zoomString = this.container.getAttribute('data-zoom') || 14;
    this.address = this.container.getAttribute('data-address');
    this.enableCorrection = this.container.getAttribute('data-latlong-correction');
    this.lat = this.container.getAttribute('data-lat');
    this.long = this.container.getAttribute('data-long');
    if (this.key) {
      this.initMaps();
    }
  }

  initMaps() {
    const urlKey = `https://maps.googleapis.com/maps/api/js?key=${this.key}`;
    loadScript({url: urlKey})
      .then(() => {
        return this.enableCorrection === 'true' && this.lat !== '' && this.long !== '' ? new window.google.maps.LatLng(this.lat, this.long) : geocodeAddressPromise(this.address);
      })
      .then((center) => {
        var zoom = parseInt(this.zoomString, 10);
        const styles = mapStyle(this.styleString);
        var mapOptions = {
          zoom,
          styles,
          center,
          draggable: true,
          clickableIcons: false,
          scrollwheel: false,
          zoomControl: false,
          disableDefaultUI: true,
        };
        const map = createMap(this.mapWrap, mapOptions);
        return map;
      })
      .then((map) => {
        this.map = map;
        allMaps[this.id] = map;
      })
      .catch((e) => {
        console.log('Failed to load Google Map');
        console.log(e);
      });
  }

  onUnload() {
    if (typeof window.google !== 'undefined') {
      window.google.maps.event.clearListeners(this.map, 'resize');
    }
  }
}

function createMap(container, options) {
  var map = new window.google.maps.Map(container, options);
  var center = map.getCenter();

  new window.google.maps.Marker({
    map: map,
    position: center,
  });

  window.google.maps.event.addDomListener(window, 'resize', function () {
    window.google.maps.event.trigger(map, 'resize');
    map.setCenter(center);
  });
  return map;
}

function geocodeAddressPromise(address) {
  return new Promise((resolve, reject) => {
    var geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({address: address}, function (results, status) {
      if (status == 'OK') {
        var latLong = {
          lat: results[0].geometry.location.lat(),
          lng: results[0].geometry.location.lng(),
        };
        resolve(latLong);
      } else {
        reject(status);
      }
    });
  });
}

const mapSection = {
  onLoad() {
    allMaps[this.id] = new Map(this);
  },
  onUnload() {
    if (typeof allMaps[this.id].unload === 'function') {
      allMaps[this.id].unload();
    }
  },
};

register('section-map', mapSection);
